//@ts-check

import Swal from 'sweetalert2';

/**
 * @param {string} message
 * @param {import("sweetalert2").SweetAlertOptions} options
 * @return {Promise<() => void>}
 */
export function accessDenied(message, options) {
  Swal.fire({
    icon: 'info',
    title: 'Access Denied',
    html: `<p style="font-size: 16px; color: #333;">${message}</p>`,
    confirmButtonText: 'Ok',
    cancelButtonColor: 'secondary',

    showCancelButton: false,
    focusConfirm: true,
    ...options,
  });

  return null;
}

export function handleLessonAccess(lessonNames, options) {
  Swal.fire({
    icon: 'info',
    title: 'Access Denied',
    html: lessonNames
      ? `
        <div style="font-size: 16px; color: #545454; line-height: 1.6;">
          <p style="color: #545454;font-weight: 600;">Please complete the below lessons</p>
          <ul style="list-style-type: none; padding: 0px; text-align: left;">
            ${lessonNames}
          </ul>
        </div>`
      : '<p style="font-size: 16px; color: #545454;">You don’t have access to this lesson.</p>',
    ...options,
  });
}

export function timeExpired(message, options, newMessage) {
  Swal.fire({
    icon: 'info',
    title: newMessage,
    html: `<p style="font-size: 16px; color: #333;">${message}</p>`,
    confirmButtonText: 'Ok',
    cancelButtonColor: 'secondary',

    showCancelButton: false,
    focusConfirm: true,
    ...options,
  });

  return null;
}
